import React, { Component } from "react";

import styled from "styled-components";
import PropTypes from "prop-types";
import StoryItemDataFieldsView from "./StoryItemDataFieldsView";
import LuciPropTypes from "../../propTypes/";
import AppSettings from "../../settings";
import {
  Container,
  MainContent,
  StickyHeader
} from "../../styled-components/Layout";
import { Thumbnail } from "../../styled-components/Thumbnail";
import { Button } from "../../styled-components/";

const StoryItemContainer = styled(Container)`
  border-bottom: 1px solid grey;
  box-sizing: border-box;
  padding-bottom: 1rem;
  padding-left: 0;
  margin-bottom: 1rem;
`;

const EditButton = styled(Button)`
  margin-left: 1rem;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
`;

const StoryItemTitle = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: bold;
  align-items: center;
`;

const StoryDataContent = styled(MainContent)`
  display: flex;
  flex-direction: row;
`;

const StoryDataItemContainer = styled.div`
  flex-basis: 75%;
  margin-right: 0.25rem;
`;

const StoryDataThumbnailContainer = styled.div`
  flex-basis: 25%;
  margin-right: 0.25rem;
`;

const StoryContainer = styled.div`
  width: 100%;
`;

const StoryTitle = styled.h4`
  width: 100%;
  background-color: #636262;
  color: white;
`;

class StoryView extends Component {
  openImage = url => {
    window.open(url, "_blank");
  };

  render() {
    const { story } = this.props;
    const headerText = story.number
      ? `${story.number} - ${story.name}`
      : story.name;
    return (
      <StoryContainer>
        <StoryTitle>{headerText}</StoryTitle>
        {story.items.map(item => {
          const dataFields = item.dataFields || [];
          return (
            <StoryItemContainer key={item.itemId}>
              <StickyHeader>
                <StoryItemTitle>
                  {item.mosObjectId}{" "}
                  <EditButton
                    onClick={() => this.props.openEditor(item.mosObjectId)}
                  >
                    Open in Editor
                  </EditButton>
                </StoryItemTitle>
              </StickyHeader>
              <StoryDataContent>
                <StoryDataItemContainer>
                  <StoryItemDataFieldsView
                    title={item.abstract}
                    dataFields={dataFields}
                  />
                </StoryDataItemContainer>
                <StoryDataThumbnailContainer
                  onDoubleClick={() =>
                    this.openImage(
                      `${AppSettings.camioServer}${item.thumbnail}`
                    )
                  }
                >
                  <Thumbnail
                    src={`${AppSettings.camioServer}${item.thumbnail}`}
                  />
                </StoryDataThumbnailContainer>
              </StoryDataContent>
            </StoryItemContainer>
          );
        })}
      </StoryContainer>
    );
  }
}

StoryView.defaultProps = {
  story: { items: [] },
  openEditor: () => {}
};

StoryView.propTypes = {
  story: LuciPropTypes.Story,
  openEditor: PropTypes.func
};

export default StoryView;



// WEBPACK FOOTER //
// ./app/components/RunningOrders/StoryView.js